import { FormikValues } from 'formik'
import { omit } from 'lodash'
import { useState } from 'react'
import { useMutation } from 'react-query'
import { useParams } from 'react-router-dom'

import Modal from '@/components/Modal'
import AppConfigInstallForm from '@/pages/SpaceAppBuilder/components/AppConfigInstallForm/AppConfigInstallForm'
import { Feature } from '@/pages/SpaceAppBuilder/utilities/interfaces'
import { featureQueryOptions } from '@/pages/SpaceAppBuilder/utilities/queries'

interface ConfigurationModalProps {
  isOpen?: boolean
  readOnly: boolean
  features: Feature[]
  onClose: () => void
}

const AppConfigurationModal = ({ isOpen = true, readOnly, features, onClose }: ConfigurationModalProps) => {
  const { spaceId, appId } = useParams<{
    spaceId: string
    appId: string
    featureId: string
  }>()
  const featureMutation = useMutation({})
  const [isSavingFeatures, setIsSavingFeatures] = useState(false)
  const handleClose = () => {
    onClose()
  }

  const submitConfig = async (values: FormikValues) => {
    setIsSavingFeatures(true)
    for (const feature of values.features) {
      // @ts-expect-error
      await featureMutation.mutateAsync([
        featureQueryOptions({
          spaceId,
          appId,
          featureId: feature.id
        }).queryKey[0],
        {
          method: 'PATCH',
          headers: { 'content-type': 'application/json' },
          body: JSON.stringify({
            ...omit(feature, ['id', 'workflow', 'createdBy', 'modifiedBy', 'createdDate', 'modifiedDate', 'audience'])
          })
        }
      ])
    }

    setIsSavingFeatures(false)
    onClose()
  }

  return (
    <Modal isOpen={isOpen} onClose={handleClose} size="md" className="py-8 px-8">
      {isSavingFeatures && (
        <>
          <div className="absolute top-0 left-0 z-10 h-full w-full rounded-md bg-white/[.8]"></div>

          <div className="absolute top-1/2 left-1/2 z-20 flex -translate-x-1/2 -translate-y-1/2 transform flex-col items-center">
            <div
              className="inline-block h-6 w-6 animate-spin rounded-full border-[3px] border-current border-t-transparent text-blue-600"
              role="status"
              aria-label="loading"
            >
              <span className="sr-only">Saving Config...</span>
            </div>
            <p className="mt-2 items-center text-base">Saving Config...</p>
          </div>
        </>
      )}

      <AppConfigInstallForm features={features} onSubmit={submitConfig} readOnly={readOnly} onCancel={handleClose} />
    </Modal>
  )
}

export default AppConfigurationModal
